const RTL = "rtl";
const LTR = "ltr";

function getLanguageDir() {
	return document.getElementsByTagName("html")[0].getAttribute("dir");
}

export function isRTL(): boolean {
	return getLanguageDir() === RTL;
}

export function isLTR(): boolean {
	return getLanguageDir() === LTR;
}
